import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging';
import { PayrollValidationModel } from './payroll-validation.model';
import { EfaactDataService } from '../efaact.data-service';

export const entityName = 'PayrollValidation';
@Injectable({ providedIn: 'root' })
export class PayrollValidationDataService extends EfaactDataService<PayrollValidationModel> {
    mapItems(item: PayrollValidationModel): PayrollValidationModel {
        return item;
        // return {
        //     ...item,
        //     id: item.RowNumber
        // };
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
